import { useSelector } from 'react-redux';

import { createSelector } from '@reduxjs/toolkit';

import { ResourceString } from '@/reducers/common/commonTypes';
import { selectResources } from '@/reducers/common/selectors';

const selectData = createSelector(selectResources, (resources) => ({
  googleBtn: resources['SignIn.googleButton'] ?? 'Sign in with Google',
  facebookBtn: resources['SignIn.facebookButton'] ?? 'Sign in with Facebook',
  appleBtn: 'Sign in with Apple',
  continueWithGoogle: resources['SignUpOptions.continueWithGoogle'] ?? 'Continue with Google',
  continueWithFacebook: resources['SignUpOptions.continueWithFacebook'] ?? 'Continue with Facebook',
  continueWithApple: resources['SignUpOptions.continueWithApple'] ?? 'Continue with Apple',
  signUpWithSocialHeading: resources['SignUpOptions.signUpWithSocial'] ?? 'Sign up with Social',
  logInWithSocialHeading: resources['SignInOptions.logInSocialHeading'] ?? 'Login with Social',
  email: resources['SignInForm.email'] ?? 'Email',
  pswd: resources['SignInForm.password'] ?? 'Password',
  signinButton: resources['SignInForm.signInButton'] ?? 'Sign in',
  loginButton: resources['SignInForm.loginButton'] ?? 'Login',
  serverErrorMsg:
    resources['SignIn.incorrectPassword'] ??
    "Looks like you've entered an incorrect email address and/or password (we get it, there are too many to remember these days). Please try again.",
  firstNameHeading: resources['SignUpForm.firstname'] ?? 'First name',
  lastnameHeading: resources['SignUpForm.lastname'] ?? 'Last name',
  emailHeading: resources['SignUpForm.email'] ?? 'Email',
  dobHeading: resources['SignUpForm.dob'] ?? 'Date of birth',
  signupContinue: resources['SignUpSocialMediaForm.submit'] ?? 'Continue',
  invalidTLDs: resources['SailorForm.InvalidTLD'] ?? 'con,von,ron,vom,comp,cdom,gom,cpm,comm,cokm',
}));

const useResourcesData = () => useSelector(selectData) as ResourceString;

export default useResourcesData;
